<div class="configure">
  <div class="header">
    <app-configuration-header (onTabEvent)="onTabEvent($event)"
                              class="header">

    </app-configuration-header>
  </div>

  <div (click)="unselectComponent($event)" *ngIf="onSldTab" class="tab-sld">
    <app-sld (componentTypeEvent)=componentTypeEvent($event) (transformerAddingEvent)=transformerAddingEvent($event)
             [displayedComponents]="currentItemct.components" [selectedComponent]="selectedComponent"
             class="sld"></app-sld>
    <app-sld-options-component [selectedComponent]="selectedComponent"
                               [ngClass]="{'panel': true, 'right-panel': true, 'hidden' : !openOptionsPanel}"
                               (deleteComponent)="deleteComponent($event)"
                               (moveCubicleEvent)="moveComponent($event)">
    </app-sld-options-component>
  </div>

  <div *ngIf="!onSldTab" class="tab-layout">
    <app-layout [displayedComponents]="currentItemct.components" [rangeName]="currentItemct.range.nameKey"></app-layout>
  </div>
  <div>
    <div [ngClass]="{'selectionClosed': !panelOpened}" class="selection" id="selection">
      <app-selection [componentType]="componentType" [transformerInfos]="addingTransformerInfos"></app-selection>
      <a (click)="slideSelection()" id="btn-selection-slide" >{{  buttonLabel | translate }}</a>
    </div>
  </div>
</div>

<!-- confirm delete dialog -->
<app-common-modal #deleteModal (onClickNoButton)="deleteModal.hide()" (onClickYesButton)="deleteComponentDispatcher()"
                  [description]="warningDeleteMessage" [name]="'deleteComponent'" [size]="'modal-sm'"
                  [title]="'T_LOOSE_DATA_TITLE' | translate">
</app-common-modal>
